import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-custom-modal',
  template: `
    <div class="modal-header">
      <h4 class="modal-title">{{ title }}</h4>
      <button type="button" class="close" (click)="close()">
        <span>&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <ng-content></ng-content>
    </div>
  `,
  styles: [`
    .modal-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 1rem;
      border-bottom: 1px solid #dee2e6;
    }
    .modal-body {
      padding: 1rem;
    }
    .close {
      background: none;
      border: none;
      font-size: 1.5rem;
      cursor: pointer;
    }
  `]
})
export class CustomModalComponent implements OnInit {
  @Input() title: string = '';
  @Input() isManualPaperwork: boolean = false;
  @Output() onClose = new EventEmitter<any>();

  ngOnInit() {
    // Initialize any required setup
  }

  close(result?: any) {
    this.onClose.emit(result);
  }
} 